import { configureStore } from '@reduxjs/toolkit';
import participantReducer from '../store/slices/participantSlice';
import spinnerReducer from '../store/slices/loaderSlice';
import alertReducer from '../store/slices/alertSlice';
import languageReducer from '../store/slices/languageSlice';

export const store = configureStore({
    reducer: {
        participant: participantReducer,
        spinner: spinnerReducer,
        alert: alertReducer,
        language: languageReducer,
    },
});